/**
 * Font array
 * @const
 * @type {string[]}
 */
// prettier-ignore
const FONTS_LIST = ["AR BONNIE", "Adobe Arabic", "Adobe Devanagari", "Adobe Song Std L", "Agency FB", "Arial CE", "Arial Hebrew Scholar", "Arial Rounded MT Bold", "Arial Unicode MS", "Arimo", "BankGothic Md BT", "Bell MT", "Caladea", "Century", "Clarendon BT", "Cooper Black", "DejaVu Sans", "DejaVu Sans Mono", "Eurostile", "Freehand521 BT", "Gentium Basic", "HP Simplified", "HP Simplified Light", "Haettenschweiler", "Helvetica", "Kohinoor Telugu", "Letter Gothic Std", "Liberation Sans", "Liberation Sans Narrow", "Linux Libertine Display G", "Lucida Blackletter", "Lucida Bright", "Lucida Sans", "Lucida Sans Typewriter", "LuzSans-Book", "MS Mincho", "MS Outlook", "MS Reference Sans Serif", "MT Extra", "Meiryo", "Microsoft Uighur", "Minion Pro", "Mistral", "Monaco", "Myanmar Text", "Myriad Pro", "News Gothic MT", "OCR-B 10 BT", "Open Sans", "OpenSymbol", "PT Serif", "Papyrus", "Perpetua", "Roman", "SAPDings", "Segoe UI Semilight", "Source Code Pro", "Source Sans Pro", "Source Sans Pro Semibold", "Swis721 BT", "Swis721 Blk BT", "Swis721 BlkCn BT", "TeamViewer10", "TeamViewer11", "TeamViewer9", "Trajan Pro", "Vrinda", "Wingdings 3", "Yu Gothic", "Yu Mincho", "ZWAdobeF"]

const hasCanvas = () => {
  const elem = document.createElement('canvas')

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return !!(elem.getContext && elem.getContext('2d'))
}

export const Fonts = {
  detect: function () {
    const text = 'mmmmmmmmmmlli'
    const fonts = []
    const fontSize = '72px'
    const baseFonts = ['monospace', 'sans-serif', 'serif']
    const baseSizes = []

    if (hasCanvas()) {
      const measureCanvas = (ctx: CanvasRenderingContext2D, font: string) => {
        // eslint-disable-next-line no-param-reassign
        ctx.font = `${fontSize} ${font}`

        return ctx.measureText(text).width
      }

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d') as CanvasRenderingContext2D
      // visually hide canvas
      canvas.width = 1
      canvas.height = 1
      canvas.style.position = 'absolute'
      canvas.style.left = '0'
      canvas.style.top = '0'
      canvas.style.pointerEvents = 'none'

      document.body.appendChild(canvas)

      for (let i = 0; i < baseFonts.length; i++) {
        baseSizes.push(measureCanvas(ctx, baseFonts[i]))
      }

      for (let i = 0; i < FONTS_LIST.length; i++) {
        for (let j = 0; j < baseFonts.length; j++) {
          if (
            baseSizes[j] !==
            measureCanvas(ctx, `${FONTS_LIST[i]}, ${baseFonts[j]}`)
          ) {
            fonts.push(FONTS_LIST[i])
            break
          }
        }
      }
    } else {
      const measureSpan = (font: string) => {
        span.style.fontFamily = font
        document.body.appendChild(span)
        const size = [span.offsetWidth, span.offsetHeight]
        document.body.removeChild(span)

        return size
      }

      const span = document.createElement('span')
      span.style.fontSize = fontSize
      span.innerHTML = text

      for (let i = 0; i < baseFonts.length; i++) {
        baseSizes.push(measureSpan(baseFonts[i]))
      }

      for (let i = 0; i < FONTS_LIST.length; i++) {
        for (let j = 0; j < baseFonts.length; j++) {
          const size = measureSpan(`${FONTS_LIST[i]}, ${baseFonts[j]}`)
          if (baseSizes[j][0] !== size[0] || baseSizes[j][1] !== size[1]) {
            fonts.push(FONTS_LIST[i])
            break
          }
        }
      }
    }

    return fonts
  },
}
